import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean?} State */
const initialState = false;

const isStarted = () => true;

const isEnded = () => false;

export default createReducer(initialState, {
  [types.FETCH_PREDEFINED_MESSAGE]: isStarted,
  [types.FETCH_PREDEFINED_MESSAGE_SUCCESS]: isEnded,
  [types.FETCH_PREDEFINED_MESSAGE_FAILURE]: isEnded,
});
